import Corvina1 from '../../../Media/Citraland Kedamaian/Corvina/Corvina (1).webp'
import Corvina2 from '../../../Media/Citraland Kedamaian/Corvina/Corvina (2).webp'
import Corvina3 from '../../../Media/Citraland Kedamaian/Corvina/Corvina (3).webp'
import Corvina4 from '../../../Media/Citraland Kedamaian/Corvina/Corvina (4).webp'
import Corvina5 from '../../../Media/Citraland Kedamaian/Corvina/Corvina (5).webp'
import Corvina6 from '../../../Media/Citraland Kedamaian/Corvina/Corvina (6).webp'
import Corvina7 from '../../../Media/Citraland Kedamaian/Corvina/Corvina (7).webp'
import Corvina8 from '../../../Media/Citraland Kedamaian/Corvina/Corvina (8).webp'
import Corvina9 from '../../../Media/Citraland Kedamaian/Corvina/Corvina (9).webp'



const Corvinaimages =[
Corvina1,Corvina2,Corvina3,Corvina4,Corvina5,Corvina6,Corvina7,Corvina8,Corvina9
]

export default Corvinaimages;